export default __webpack_public_path__ + "assets/images/email-ors-checkout-footer.png";